import { Form, Formik } from 'formik';
import React, { memo } from 'react';

import Fields from './fields';

interface IProps {
  product?: number;
  onChange: (product: number) => void;
}

const Filters = ({ product, onChange }: IProps) => {
  return (
    <div>
      <Formik initialValues={{ product_id: product }} onSubmit={() => null}>
        {() => (
          <Form>
            <Fields onChange={onChange} />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default memo(Filters);
